import { initializeApp } from 'firebase/app';
import { 
  getFirestore, 
  connectFirestoreEmulator,
  FirestoreError,
  enableIndexedDbPersistence
} from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getMessaging } from 'firebase/messaging';

// Firebase configuration for Stadsauktion Sundsvall Pickup
const firebaseConfig = {
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "stadsauktion-sundsvall-pickup",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:774969797852:web:3aafd3eb42ab606a8d1819",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "stadsauktion-sundsvall-pickup.firebasestorage.app",
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "stadsauktion-sundsvall-pickup.firebaseapp.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "774969797852",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-TV3HQL3SNF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Enable persistence (will show deprecation warning but still works)
if (process.env.NODE_ENV === 'production') {
  enableIndexedDbPersistence(db).catch((err: FirestoreError) => {
    if (err.code === 'failed-precondition') {
      console.warn('Multiple tabs open, persistence can only be enabled in one tab at a time.');
    } else if (err.code === 'unimplemented') {
      console.warn('The current browser does not support persistence.');
    } else {
      console.warn('Failed to enable Firestore persistence:', err);
    }
  });
}

const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Initialize Firebase Messaging - only in browser environment
let messaging = null;
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    // @ts-ignore - Type compatibility issue with Firebase app versions
    messaging = getMessaging(app);
    console.log('Firebase messaging initialized successfully');
  } catch (error) {
    console.error('Error initializing Firebase messaging:', error);
  }
}

// Connect to emulators in development mode or when running locally
if (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  try {
    connectFirestoreEmulator(db, '127.0.0.1', 8081);
    connectStorageEmulator(storage, '127.0.0.1', 9198);
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
    connectFunctionsEmulator(functions, '127.0.0.1', 5001);
    console.log('Using Firebase emulators in development mode');
  } catch (error) {
    console.warn('Failed to connect to emulators (they may already be connected):', error);
  }
}

export { app, db, auth, storage, functions, messaging };

export default app; 